
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/razorpay-checkout/[orderId]",
      function () {
        return require("private-next-pages/razorpay-checkout/[orderId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/razorpay-checkout/[orderId]"])
      });
    }
  